import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isQueryValid'
})
export class IsQueryValidPipe implements PipeTransform {

  transform(query: string, words: any): boolean {

    if (!query) {
      return true;
    }
    // TODO TO BE TRANSLATED IN TS
    var numOpen = (query.split("(").length - 1);
    var numClosed = (query.split(")").length - 1);

    if (numOpen != numClosed) {
        //console.log("NO matching brackets");
        return false;
    }

    var list = query.split(" ");
    var index = 0;
    for (var i = 0; i < list.length; i++) {
        var word = list[i].replace(/\(/g, '');
        word = word.replace(/\)/g, '');

        numOpen = (list[i].split("(").length - 1);
        numClosed = (list[i].split(")").length - 1);

        if (numOpen >= 1 && index % 4 != 3 && index % 4 != 0) {
            //console.log("START bracket wrong id");
            return false;
        }
        if ((list[i].indexOf(')') != list[i].length - 1 && numClosed >= 1 && index % 4 != 3) || (list[i] == ")" && index % 4 != 3)) {
            //console.log("END bracket wrong id");
            return false;
        }
        if (word != "") {
            index++;
        } else {
            continue;
        }

        var suggest = (index - 1) % 4;
        switch (suggest) {
            case 0:
                if (words.ids.indexOf(word.toUpperCase()) == -1) {
                    //console.log("EMPTY id");
                    return false;
                }
                break;
            case 1:
                if (words.mathOperators.indexOf(word.toUpperCase()) == -1) {
                    //console.log("EMPTY math");
                    return false;
                }
                break;
            case 2:
                if (list[i] == "") {
                    //console.log("EMPTY value");
                    return false;
                }
                break;
            case 3:
                if (words.operators.indexOf(word.toUpperCase()) == -1) {
                    //console.log("AND/OR not found");
                    return false;
                }
                break;
            default:
        }


    }
    var lastIndex = (index - 1) % 4;
    return lastIndex == 2;
  }

}
